/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the My Account form.
 * @export
 */
export const MY_ACCOUNT_DATA_IDS = {
  firstName: `Form Field: Update first name`,
  lastName: `Form Field: Update last name`,
  resetButton: `Form button: Reset form values`,
  saveButton: `Form button: Update user profile`,
  successToast: `Toast: User profile updated`,
};

/**
 * The form field ids used in the My Account form.
 * @export
 */
export const MY_ACCOUNT_FORM_IDS = {
  email: `email`,
  firstName: `first-name`,
  lastName: `last-name`,
  saveButton: `save-profile`,
};
